import { useMemo } from 'react';
import type { Composition } from '../timeline/types';
import { usePieceModel } from './piece-context';
import { modelToComposition } from './converters/model-to-composition';

/** Builds the Composition shape from the model to feed the timeline and playback. Memoized per model. */
export const useModelComposition = (): Composition => {
  const model = usePieceModel();
  return useMemo(() => modelToComposition(model), [model]);
};
